"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInsertFileHandler = getInsertFileHandler;

var _tinymce = _interopRequireDefault(require("tinymce"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _userInfo = require("hub-http/userInfo");

var _Constants = require("FileManagerLib/Constants");

var _utils = require("../utils");

var _usageTracking = require("../constants/usageTracking");

var _settings = require("../utils/settings");

var _usageTracking2 = require("./usageTracking");

// DOM nodes created to serve as render targets for React
var domNodes = {};

var getInsertHandler = function getInsertHandler(editor, callback) {
  return function (file) {
    callback(file);
    editor.focus();
    (0, _usageTracking2.trackInteraction)(editor, 'tinymceEdit', _usageTracking.INSERT_LINK_TO_FILE);
  };
};

function renderFileManager(editor, callback) {
  if (!domNodes.fileManager) {
    var container = (0, _utils.appendDivToEditor)(editor);

    if (!container) {
      console.error('Could not append div to editor.');
      return;
    }

    domNodes.fileManager = container;
  }

  var insertFileLink = getInsertHandler(editor, callback);
  var FilePicker = (0, _settings.getPickerComponent)(editor, 'FilePicker');

  var unmountDrawer = function unmountDrawer() {
    _reactDom.default.unmountComponentAtNode(domNodes.fileManager);
  };

  var onCloseComplete = function onCloseComplete() {
    _tinymce.default.util.Delay.setEditorTimeout(editor, function () {
      editor.focus();
    });
  };

  var handleInsert = function handleInsert(file) {
    insertFileLink(file.toJS());
    unmountDrawer();
  };

  _reactDom.default.render(_react.default.createElement(FilePicker, {
    className: "mce-file-picker",
    dropdownClassName: "mce-file-picker-uploader",
    onClose: unmountDrawer,
    onCloseComplete: onCloseComplete,
    onSelect: handleInsert,
    pickerType: "SIDE_MODAL",
    type: _Constants.DrawerTypes.FILE,
    userInfo: (0, _userInfo.userInfoSync)()
  }), domNodes.fileManager);
}

function getInsertFileHandler(editor) {
  return function (insertFileCallback) {
    renderFileManager(editor, insertFileCallback);
  };
}